module.exports = __webpack_public_path__ + "fonts/icomoon.07cc1eba.030afbe.eot";